import { render, staticRenderFns } from "./jinqihuodongdetail.vue?vue&type=template&id=35296313&scoped=true"
import script from "./jinqihuodongdetail.vue?vue&type=script&lang=js"
export * from "./jinqihuodongdetail.vue?vue&type=script&lang=js"
import style0 from "./jinqihuodongdetail.vue?vue&type=style&index=0&id=35296313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35296313",
  null
  
)

export default component.exports